import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ISocialMediaResponse } from "../../../../store/socialMediaMonitoringService/types";
import * as SocialMediaActions from "../../../../store/socialMediaMonitoringService/actions";
import * as ConfigurationActions from "../../../../store/configurationService/actions";
import { ApplicationState } from "../../../../store";
import { useHistory } from "react-router-dom";
import { GetServiceDetails } from "../../../../store/common";

interface IProps {
    location: any;
}

type ISocialMediaProps = IProps;

const SocialMediaCallback: React.FunctionComponent<ISocialMediaProps> = (props) => {
    const history = useHistory();
    var isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
    const renderSiteInIFrame: any = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.renderInIframe
            ? state.configurationState.configuration.partnerConfig.renderInIframe
            : false
    );
    const [displayNoYoutubeChannel, setDisplayNoYoutubeChannel] = useState(false);
    const dispatch = useDispatch();
    const requestSocialMedia = (socialMediaResponse: ISocialMediaResponse) => dispatch(SocialMediaActions.actionCreators.requestCallback(socialMediaResponse));
    const routeLoading = useSelector((state: ApplicationState) => state.configurationState && (state.configurationState.loading || false));
    let componentUnloaded = false;

    const handleWindowClose = () => {
        if (renderSiteInIFrame && isSafari) {
            // Dont close window
            console.log("handleWindowClose called for safari");
        } else {
            window.close();
        }
    };

    const getSocialMedia = () => {
        const query = new URLSearchParams(props.location.search);
        let socialMediaResponse: ISocialMediaResponse = {};
        socialMediaResponse.account_number = query.get("account_number")!;
        socialMediaResponse.token = query.get("token")!;
        socialMediaResponse.refresh_token = query.get("refresh_token")!;
        socialMediaResponse.token_expiration = query.get("token_expiration")!;
        socialMediaResponse.network = query.get("network")!;
        socialMediaResponse.secret = query.get("secret")!;

        if (window?.opener) {
            window?.opener?.postMessage(socialMediaResponse, window?.location?.origin);
        }

        requestSocialMedia(socialMediaResponse);
        handleWindowClose();
    };
    useEffect(() => {
        if (componentUnloaded === false) {
            const query = new URLSearchParams(props.location.search);
            const error = query.get("error");

            if (error === "no_channel") {
                setDisplayNoYoutubeChannel(true);
            } else if (error) {
                handleWindowClose();
            } else {
                // const codeValue = query.get("code");

                if (renderSiteInIFrame && isSafari) {
                    GetServiceDetails(dispatch, false, null, () => {
                        getSocialMedia();
                        history.push({
                            pathname: "/identity-vault",
                            search: props.location.search,
                        });
                    });
                } else {
                    getSocialMedia();
                }
            }
        }
        return () => {
            componentUnloaded = true;
        };
    }, []);

    useEffect(() => {
        if (routeLoading) {
            dispatch(ConfigurationActions.actionCreators.setRouteLoading(false));
        }
    }, [dispatch, routeLoading]);

    return (
        <React.Fragment>
            {displayNoYoutubeChannel ? (
                <div className="row sm-message-container">
                    <div className="box offset-padding">
                        <div className="box-header">
                            <div className="box-title-container">
                                <div className="box-title-icon dashboard-alert-icon" aria-hidden="true">
                                    <em className="las la-exclamation-triangle"></em>
                                </div>
                                <div className="box-title-text has-actions">
                                    <h2 className="box-title">Failed to add social media account</h2>
                                </div>
                            </div>
                        </div>
                        <div className="box-content">
                            <p>
                                Failed to connect your account. To use this feature, you must have a YouTube channel with at least one video uploaded. Please make
                                sure you have a YouTube channel associated with your Google account before trying again.
                            </p>
                            <p>
                                If you just watch YouTube without posting videos, you likely have a Google account and not a YouTube channel. Even if you have a
                                Google account, you need to create a YouTube channel to upload videos, comment, or make playlists.
                            </p>
                        </div>
                    </div>
                </div>
            ) : (
                <div role="row" className="data-row row">
                    <div className="box loading" style={{ width: "100%" }}></div>
                </div>
            )}
        </React.Fragment>
    );
};

export default SocialMediaCallback;
